export const getProfileCompanyId = (profile) => profile?.corporate?.company?.id;
